import { __decorate, __metadata } from "tslib";
import { IsUndefinable } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsDefined, IsOptional, IsString } from 'class-validator';
import { WebStoreExposeGroup } from '../interface';
export class ReadWebStoreMetadataCustomMessagesDto {
}
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "loginRegister", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "gratuity", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "itemNotes", void 0);
__decorate([
    ApiProperty({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebStoreExposeGroup.PATCH] }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "orderNotes", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "selectReceiveMethod", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "receivedMethodButtons", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "deliveryAddress", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "footerPage", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "orderConfirmation", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "clearCartButtonName", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "backButtonName", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "itemModal", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "curbsidePickupAsapInfoMessage", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "asapInfoMessage", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "loyaltyInfo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "topBarMessages", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "cartButtonsText", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "orderComplete", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "orderReminder", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "payment", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "paymentForm", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "unsupportedBrowser", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "menuList", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebStoreMetadataCustomMessagesDto.prototype, "prepTime", void 0);
//# sourceMappingURL=ReadWebStoreMetadataCustomMessagesDto.js.map